<template>
  <div id="cnt" class="w-75">
    <Chart class="ch"></Chart>
    <List class="ls"></List>
  </div>
</template>

<script>

import Chart from '@/components/Chart';
import List from '@/components/List';

export default {
  components: {
    Chart,
    List,
  }
};
</script>


<style>

.ls{
  z-index: 100;
  width: 700px;
  height: 600px;
  background-color: rgba(255, 255, 255, 0.5);


}

.ch {
  z-index: 1;
  position: absolute;
}

#cnt {
  height: 600px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 15px;
}
</style>
